import { AppConfig } from '../enums/app-config';

declare global {
  const appConfig: AppConfig;

  interface Window {
    systemConfig: {
      daysToSignUpPayDate: number;
      daysToAcceptFromWaitListPayDate: number;
      daysToSendReminderPayDate: number;
      daysToLastCyclePayDate: number;
      daysToKeepBackups: number;
      systemMailReceipientMail: string;
      systemMailReceipientName: string;
      systemMailSenderMail: string;
      systemMailReplyMail: string;
      systemMailReplyName: string;
      daysBeforeSwapMeetOpens: number;

      systemNote: string;
      swapMeetNote: string;
      accountNote: string;
      managerNote: string;

      imageKitEndpoint: string;
    };
  }
}

export enum OrderDirection {
  UP = 'up',
  DOWN = 'down',
}
